<template>
  <button :disabled="disabled" :class="classes" :style="{backgroundColor: bgcolor, color: color}" :data-track="track">
    <slot></slot>
  </button>
</template>

<script>
  import {isColor} from '../assets/utils';

  export default {
    name: 'button',
    props: {
      disabled: Boolean,
      type: {
        validator(value) {
          return ['primary', 'danger', 'warning', 'hollow', 'disabled', 'normal'].indexOf(value) > -1;
        },
        default: 'normal'
      },
      size: {
        validator(value) {
          return ['small', 'large'].indexOf(value) > -1;
        }
      },
      bgcolor: {
        validator(value) {
          let bgFlag = true;
          if (!value) {
            bgFlag = true;
          } else {
            bgFlag = isColor(value);
          }
          return bgFlag;
        }
      },
      color: {
        validator(value) {
          let cologFlag = true;
          if (!value) {
            cologFlag = true;
          } else {
            cologFlag = isColor(value);
          }
          return cologFlag;
        }
      },
      track: ''
    },
    computed: {
      classes() {
        const s = this.size === 'large' ? 'btn-block' : 'btn';
        let b = `btn-${this.type}`;
        if (this.disabled) {
          b = 'btn-disabled';
        }

        if (this.bgcolor) {
          b = '';
        }
        return `${s}  ${b}`;
      }
    }
  };
</script>

<style lang="less">
  @import "../assets/base.less";

  .m-button {
    padding: 0 20px;
  }

  .btn-variant() {
    text-align: center;
    position: relative;
    border: none;
    pointer-events: auto;
  }

  .btn {
    .btn-variant();
    height: 30px;
    font-size: 26px;
    display: inline-block;
    padding: 0 20px;
    box-sizing: content-box;
    border-radius: 8px;
  }

  .btn-block {
    .btn-variant();
    width: 100%;
    display: block;
    font-size: 36px;
    height: 100px;
    margin-top: 70px;
    border-radius: 8px;
  }

  .btn-primary, .btn-normal {
    background-color: @color-main;
    color: #fff;
  }

  .btn-danger {
    background-color: @color-main;
    color: #fff;
  }

  .btn-warning {
    background-color: @color-main;
    color: #fff;
  }

  .btn-disabled {
    background-color: @color-gray-light;
    color: #fff;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// Btn.vue?455f60a8